import React from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import useIdleLogout from '../auth/useIdleLogout';
import SuperMobileStyles from './SuperMobileStyles';

export default function SuperShell() {
  const nav = useNavigate();

  useIdleLogout(5 * 60 * 1000);

  const Tab = ({ to, children }) => (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `px-3 py-1 rounded-full text-sm ${isActive ? 'bg-cyan-600 text-white' : 'text-cyan-300 hover:bg-cyan-900/30'}`
      }
    >
      {children}
    </NavLink>
  );

  return (
    <div className="super-admin-root min-h-screen bg-[#0b0f19] text-white">
      <SuperMobileStyles />
      <header className="super-admin-topbar sticky top-0 z-10 backdrop-blur bg-[#0b0f19]/80 border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between">
          <h1 className="super-admin-title text-lg font-semibold">Super Admin</h1>
          <nav className="super-admin-nav flex items-center gap-2 flex-wrap justify-end">
            <Tab to="/super">Home</Tab>
            <Tab to="/super/founder">Founder Metrics</Tab>
            <Tab to="/super/orgs">Organizations</Tab>
            <Tab to="/super/usage">Usage</Tab>
            <Tab to="/super/tools">Tools</Tab>
            <Tab to="/super/download">Download</Tab>
            <Tab to="/super/support">Support</Tab>
            <Tab to="/super/scouts">Scouts</Tab>
            <Tab to="/super/ontime">On Time</Tab>
            <Tab to="/super/archives">Archives</Tab>
            <button
              onClick={async () => { await signOut(getAuth()); nav('/login', { replace: true }); }}
              className="ml-3 px-3 py-1 rounded bg-rose-600 hover:bg-rose-500 text-sm"
            >
              Logout
            </button>
          </nav>
        </div>
      </header>

      <main className="super-admin-main max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
